/** Layout Home */
(function (fox, $) {
  "use strict";

  const getMaxDiscount = require("../../components/common/getMaxDiscount")(fox);

  fox.registerWidget(
    "Layout_Home",
    {
      configure: function () {
        this.registerOptions("", {
          widgets: {
            "mainMenu.widget": "Menu_Main",
            "footer.widget": "Site_Footer",
          },
          newMessageSelector: "#messages-number",
          "templateOptions.maxDiscount": getMaxDiscount(),
          handleWom: {
            newMessagesCount: {
              event: "cameNewMessages",
              widget: "@root #newMessageCount",
              "params.prefix": "formessagecounter",
              callback: function (data) {
                var mn = this.dom(this.getOption("newMessageSelector"));

                fox.each(mn, function (n) {
                  if (fox.dom.isDomNode(n)) {
                    n.innerHTML = data.total > 0 ? data.total : "";

                    if (data.total > 0 && $(n).css("display") === "none") {
                      $(n).css("display", "inherit");
                    }
                  }
                });
              },
            },
            firstLoad: {
              widget: "@this",
              event: "addedToDom",
              callback: "_goToPageAnalytics",
            },
            goToPageAnalytics: {
              widget: fox.Navigator,
              event: "modified_0",
              callback: "_goToPageAnalytics",
            },
          },
        });

        this.callParent("configure", arguments);
      },

      running: function () {
        this._resizeTimer = null;
        this._addResizeHandler();

        this.callParent("running", arguments);
      },

      activate: function () {
        this._addResizeHandler();

        this.callParent("activate", arguments);
      },

      deactivate: function (argument) {
        this._removeResizeHandler();

        this.callParent("deactivate", arguments);
      },

      _addResizeHandler: function (argument) {
        $(window).on("resize", { widget: this }, this._handleResize);
      },

      _removeResizeHandler: function (argument) {
        $(window).off("resize", this._handleResize);
      },

      _handleResize: function (e) {
        var _this = e.data.widget;

        if (_this._resizeTimer) {
          return;
        }

        _this._resizeTimer = window.setTimeout(function () {
          _this.dispatchEvent("windowResize");
          _this._resizeTimer = false;
        }, 1000);
      },

      _goToPageAnalytics: function () {
        var api = this.getApi("trckApi", { method: "trck-v1" }),
          data = {},
          page =
            fox.Navigator.get(0) === false
              ? "/home"
              : `/${fox.Navigator.get(0)}`;
        data.added = new Date().getTime();
        data.event = "pageview";
        data.b64message = btoa(
          JSON.stringify({ page: encodeURIComponent(page) })
        );
        api.psend(data);
      },
    },
    "Site_Layout"
  );
})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/layout/home.es.js